/**
 * 어트랙트 화면 브랜딩 설정 — DynamoDB `booth-{env}-branding` 테이블, id="default".
 * 단일 테넌트. 이미지 모드 / 텍스트 모드 토글.
 */
export const DEFAULT_BOOTH_BRANDING = {
    id: "default",
    mode: "text",
    updatedAt: new Date(0).toISOString(),
};
//# sourceMappingURL=branding.js.map